module.exports = __webpack_public_path__ + "img/arrorw.1ebfbfc9.png";